import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { VisaTypeApi } from '../../../api/visa-type/visa-type.api';
import { Box, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Typography } from '@mui/material';
import InputTextField from '../../../components/input/inputTextField';
import AddImage from "../../../assets/icons/add_image.png";
import { ReactComponent as CloseCircle } from "../../../assets/icons/close-circle.svg";
import { handleTypingNumber } from '../../../utils/app.utils';
import InputDatePicker from '../../../components/input/inputDatePicker';
import moment from 'moment';
import { routeName } from '../../../routes/routeName';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { VisaFormApi } from '../../../api/visa-form/visa-form.api';
import { alertSuccess, swalError } from '../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';

export default function ManageRequestFormDetail(props: any) {
    const { view } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const uploadRefs = useRef<any>();

    const navigate = useNavigate()
    const [pathUrl, setPathUrl] = useState<any>(null);

    const [form, setForm] = useState<any>({
        visa_document_fee: 0,
        payment_period_inside_day: 0,
        payment_period_inside_hour: 0,
        payment_period_day_start: null,
        payment_period_day_end: null,
        payment_period_type: 'NONE'
    });
    const [visaType, setVisaType] = useState<any[]>([]);
    const [files, setFiles] = useState<any[]>([]);
    const [filesRemove, setFilesRemove] = useState<any[]>([]);

    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results);
        };
        init();
    }, []);
    const findById = async () => {

        await VisaFormApi.findById(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data?.data);
                setFiles(res.data?.data?.visa_form_files)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getVisaType()
        if (id) {
            findById()

        }
    }, [])
    const handleSubmit = async () => {
        const body = {
            ...form,
            status: 'active'
        }
        dispatch(setLoading());
        if (id) {
            await VisaFormApi.patch(body, +id)
                .then(async (res) => {
                    if (res.status < 300) {
                        if (files?.filter((x) => !x?.id_visa_form_file)?.length > 0) {
                            const formData = new FormData();

                            files.forEach((file) => {
                                formData.append("files", file);
                            });

                            await VisaFormApi.file(res.data.data.id_visa_form, formData)
                                .then((res) => {
                                    if (res.status < 300) {
                                    }
                                })
                        }
                        if (filesRemove?.length > 0) {

                            filesRemove.forEach(async (file) => {
                                await VisaFormApi.deleteFile(id, file?.id_visa_form_file)
                                    .then((res) => {
                                        if (res.status < 300) {
                                        }
                                    })
                            });


                        }
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request_forms));
                    }
                })
                .catch((err) => {
                    console.log(err);
                    swalError(err?.response?.data?.message || t('LIST_APPLICANTS_ERROR'))
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        } else {
            await VisaFormApi.post(body)
                .then(async (res) => {
                    if (res.status < 300) {
                        if (files?.filter((x) => !x?.id_visa_form_file)?.length > 0) {
                            const formData = new FormData();

                            files.forEach((file) => {
                                formData.append("files", file);
                            });

                            await VisaFormApi.file(res.data.data.id_visa_form, formData)
                                .then((res) => {
                                    if (res.status < 300) {
                                    }
                                })
                        }
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request_forms));
                    }
                })
                .catch((err) => {
                    console.log(err);
                    swalError(err?.response?.data?.message || t('LIST_APPLICANTS_ERROR'))
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("สร้างฟอร์มคำร้อง")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ระบบคำร้อง"),
                                disabled_match: true,
                                pathName: routeName.request_form.manage_request_forms
                            },
                            {
                                key: "complaintSubmit",
                                name: t("จัดการฟอร์มคำร้อง"),
                                pathName: routeName.request_form.manage_request_forms
                            },
                            {
                                key: "complaintSubmit",
                                name: t("สร้างฟอร์มคำร้อง"),
                                pathName: routeName.request_form.manage_request_form_add
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <ContainerButton
                        // sxContainer={{ my: 3 }}
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: () => { navigate(-1) },
                                },
                                key: "CANCEL",
                                label: t("LIST_APPLICANTS_BACK"),
                                type: "CANCEL"
                            },
                            // {
                            //     seq: 2,
                            //     buttonProps: {
                            //         onClick: () => {
                            //             //   setShowModal('REJECT')
                            //             handleSubmit()
                            //         }
                            //     },
                            //     key: "SAVE_DRAFT",
                            //     label: t("บันทึกร่าง"),
                            //     type: 'SAVE_DRAFT'
                            // },
                            {
                                seq: 2,
                                hidden: view,
                                buttonProps: {
                                    onClick: () => {
                                        //   alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                                        //     handleVerified()
                                        //   })
                                        handleSubmit()
                                    }
                                },
                                key: "SAVE",
                                label: t("ยืนยัน"),
                                type: 'SAVE'
                            },
                        ]}
                    />
                }
                content={
                    <div style={{ maxWidth: "1000px", margin: '0px auto' }}>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("ชื่อฟอร์มคำร้อง"),
                                        value: form?.visa_form_name || '',
                                        onChange: (e) => {
                                            setForm({ ...form, visa_form_name: e.target.value })
                                        },
                                        disabled: view
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("หัวเรื่อง"),
                                        value: form?.visa_form_subject || '',
                                        onChange: (e) => {
                                            setForm({ ...form, visa_form_subject: e.target.value })
                                        },
                                        disabled: view
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        // md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: t("รูปแบบฟอร์มคำร้อง"),
                                        disabled: view,
                                        value: form?.id_visa_type || '',
                                        onChange: (e) => {
                                            setForm({ ...form, id_visa_type: e.target.value, payment_period_type: 'NONE', payment_period_inside_day: 0, payment_period_inside_hour: 0, payment_period_day_start: null, payment_period_day_end: null })
                                        },
                                        options: [
                                            ...visaType?.map((item: any) => {
                                                return {
                                                    label: item?.visa_type_name,
                                                    value: item?.id_visa_type,
                                                }
                                            })
                                        ],
                                        selectId: "",
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    hidden: !(form?.id_visa_type && visaType?.find((item: any) => item?.id_visa_type === form?.id_visa_type)?.is_payment === 1),
                                    fieldProps: {
                                        disabled: view,
                                        heading: t("ค่าธรรมเนียม (บาท)"),
                                        value: form?.visa_document_fee || '',
                                        onChange: (e) => {
                                            setForm({ ...form, visa_document_fee: e.target.value })
                                        },
                                        onkeypress: handleTypingNumber
                                    }
                                },

                            ]
                            } />
                        {
                            (form?.id_visa_type && visaType?.find((item: any) => item?.id_visa_type === form?.id_visa_type)?.is_payment === 1) &&
                            <>
                                <Typography sx={{ fontSize: '18px', fontWeight: '600', marginTop: '15px' }}>{t("ระยะเวลาที่เปิดให้ชำระ")}</Typography>
                                <RadioGroup
                                    value={form?.payment_period_type || ''}
                                    onChange={(e) => {
                                        setForm({ ...form, payment_period_type: e.target.value, payment_period_inside_day: e.target.value !== 'DAY' ? 0 : form?.payment_period_inside_day, payment_period_inside_hour: e.target.value !== 'DAY' ? 0 : form?.payment_period_inside_hour, payment_period_day_start: e.target.value !== 'PERIOD' ? null : form?.payment_period_day_start, payment_period_day_end: e.target.value !== 'PERIOD' ? null : form?.payment_period_day_end })
                                    }}
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                >
                                    <FormControlLabel value="NONE" disabled={view} control={<Radio />} label={t("ไม่จำกัด")} />
                                    <FormControlLabel value="DAY" disabled={view} control={<Radio />} label={<Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}><Typography>{t("ภายใน")}</Typography><InputTextField
                                        value={form?.payment_period_inside_day}
                                        onChange={(e) => {
                                            setForm({ ...form, payment_period_inside_day: e.target.value })
                                        }} onkeypress={handleTypingNumber} disabled={view} style={{ width: '150px' }} /><Typography>{t("วัน")}</Typography><InputTextField
                                            value={form?.payment_period_inside_hour}
                                            onChange={(e) => {
                                                setForm({ ...form, payment_period_inside_hour: e.target.value })
                                            }} onkeypress={handleTypingNumber} disabled={view} style={{ width: '150px' }} /><Typography>{t("ชั่วโมง หลังเจ้าหน้าที่ยืนยัน")}</Typography></Box>} />
                                    <FormControlLabel value="PERIOD" disabled={view} control={<Radio />} label={<Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '5px' }}><Typography>{t("ภายในวันที่")}</Typography>
                                        <InputDatePicker
                                            value={form?.payment_period_day_start}
                                            onChange={(e) => {
                                                setForm({ ...form, payment_period_day_start: moment(e).format('YYYY-MM-DD') })
                                            }} disabled={view} /><Typography>{t("ถึงวันที่")}</Typography><InputDatePicker
                                            value={form?.payment_period_day_end}
                                            onChange={(e) => {
                                                setForm({ ...form, payment_period_day_end: moment(e).format('YYYY-MM-DD') })
                                            }}
                                            disabled={view}
                                        /></Box>} />
                                </RadioGroup>
                            </>
                        }

                        <Box sx={{ padding: '40px', borderBottom: '8px solid #2186E3', boxShadow: '0px 0px 10px 0px #00000026', borderRadius: '16px', margin: '20px 0px', display: 'flex', flexDirection: "column", gap: '10px' }}>
                            <Typography>{t("รูปแบบ : คำอธิบายรายละเอียด")}</Typography>
                            <InputTextField heading={t("รายละเอียด")} value={form?.visa_form_desc}
                                onChange={(e) => {
                                    setForm({ ...form, visa_form_desc: e.target.value })
                                }} disabled={view} />
                            <Typography>{t("เพิ่มไฟล์")}</Typography>
                            <Box sx={{
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid #DDE1EB'
                            }}>
                                <Grid container spacing={2}>
                                    {files?.map((item: any, index: number) => {
                                        return (
                                            <Grid key={index} item xs={12} md={2}>
                                                <img src={item?.id_visa_form_file ? `${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}` : URL.createObjectURL(item)} style={{
                                                    width: '137px',
                                                    height: '137px',
                                                    objectPosition: 'center',
                                                    objectFit: 'contain'
                                                }} />
                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <Typography sx={{
                                                        width: '70%',
                                                        fontSize: '12px',
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: "1",
                                                        overflow: "hidden",
                                                    }}>{item?.name || item?.file_name}</Typography>
                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {
                                                        if (item?.id_visa_form_file) {
                                                            setFilesRemove([...filesRemove, item])
                                                        }
                                                        setFiles(files?.filter((_, i) => i !== index))

                                                    }}>
                                                        <CloseCircle />
                                                    </Box>}
                                                </Box>

                                            </Grid>
                                        )
                                    })}
                                    <Grid item xs={12} md={2}>
                                        <img src={AddImage} style={{
                                            cursor: 'pointer',
                                        }} onClick={() => !view && uploadRefs.current?.click()} />
                                        <input type='file' accept="image/png, image/jpeg" ref={uploadRefs} onChange={(e: any) => {
                                            if (e.target.files[0]) {
                                                setFiles([...files, e.target.files[0]])
                                            }
                                        }} style={{ display: 'none' }} />
                                    </Grid>
                                </Grid>

                            </Box>

                        </Box>

                    </div>
                }
            />

            <ContainerButton
                sxContainer={{ my: 3 }}
                // justifyContent='flex-end'
                buttonData={[
                    {
                        seq: 1,
                        buttonProps: {
                            onClick: () => { navigate(-1) },
                        },
                        key: "CANCEL",
                        label: t("LIST_APPLICANTS_BACK"),
                        type: "CANCEL"
                    },
                    // {
                    //     seq: 2,
                    //     buttonProps: {
                    //         onClick: () => {
                    //             //   setShowModal('REJECT')
                    //             handleSubmit()
                    //         }
                    //     },
                    //     key: "SAVE_DRAFT",
                    //     label: t("บันทึกร่าง"),
                    //     type: 'SAVE_DRAFT'
                    // },
                    {
                        seq: 2,
                        hidden: view,
                        buttonProps: {
                            onClick: () => {
                                //   alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                                //     handleVerified()
                                //   })
                                handleSubmit()
                            }
                        },
                        key: "SAVE",
                        label: t("ยืนยัน"),
                        type: 'SAVE'
                    },
                ]}
            />
        </div >
    )
}
